import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** "1 email", "3 emails". Pass a custom plural for irregular nouns. */
export function plural(count, noun, pluralNoun) {
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? noun : pluralNoun || `${noun}s`}`;
}
